import { Dayjs } from "utils/dayjs"
import { toDateTimeKeepingOffset, toDayjsWithoutTimezone } from "utils/utils"

export interface IReservationTimeDto {
    reservationStart: string
    reservationEnd?: string
}

export default class ReservationTime {
    reservationStart: Dayjs
    reservationEnd?: Dayjs

    readonly originalStart?: string
    readonly originalEnd?: string

    constructor(dto: IReservationTimeDto) {
        this.reservationStart = toDayjsWithoutTimezone(dto.reservationStart)
        this.reservationEnd = dto.reservationEnd ? toDayjsWithoutTimezone(dto.reservationEnd) : undefined
        this.originalStart = dto.reservationStart
        this.originalEnd = dto.reservationEnd
    }

    toDto(): IReservationTimeDto {
        return {
            reservationStart: toDateTimeKeepingOffset(this.reservationStart, this.originalStart),
            reservationEnd: this.reservationEnd
                ? toDateTimeKeepingOffset(this.reservationEnd, this.originalEnd)
                : undefined,
        }
    }
}
